import { useCallback, useState } from "react";

import ShareModal from "@/components/share/ShareModal";
import {
  canNativeShare,
  getShareData,
  isAbortError,
  isTouchDevice,
  type ShareTarget,
} from "@/components/share/share.utils";
import { analytics, EventEnum } from "@/lib/analytics";

/** OS share sheet on phones; Lutely share modal elsewhere or if it fails. */
export function useShare() {
  const [target, setTarget] = useState<ShareTarget | null>(null);

  const share = useCallback(async (next: ShareTarget) => {
    if (isTouchDevice() && canNativeShare(next.url)) {
      analytics.track(EventEnum.SHARE_MENU_OPENED, {
        url: next.url,
        kind: next.kind,
        surface: "native",
      });
      try {
        await navigator.share(getShareData(next));
        analytics.track(EventEnum.SHARE_CREATED, {
          url: next.url,
          kind: next.kind,
          channel: "native",
        });
        return;
      } catch (error) {
        if (isAbortError(error)) return;
      }
    }
    setTarget(next);
  }, []);

  const shareModal = target ? (
    <ShareModal
      open
      onOpenChange={(open) => {
        if (!open) setTarget(null);
      }}
      target={target}
    />
  ) : null;

  return { share, shareModal };
}
